import { render, staticRenderFns } from "./InventoryApproachingExpirationWindow.vue?vue&type=template&id=39aa28b1&scoped=true&"
import script from "./InventoryApproachingExpirationWindow.vue?vue&type=script&lang=js&"
export * from "./InventoryApproachingExpirationWindow.vue?vue&type=script&lang=js&"
import style0 from "./InventoryApproachingExpirationWindow.vue?vue&type=style&index=0&id=39aa28b1&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39aa28b1",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\agent\\_work\\11\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('39aa28b1')) {
      api.createRecord('39aa28b1', component.options)
    } else {
      api.reload('39aa28b1', component.options)
    }
    module.hot.accept("./InventoryApproachingExpirationWindow.vue?vue&type=template&id=39aa28b1&scoped=true&", function () {
      api.rerender('39aa28b1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/availableInventories/InventoryApproachingExpirationWindow.vue"
export default component.exports